export default __webpack_public_path__ + "maps-examples-fill-pattern-thumbnail-960-b5f0067e129e9e9c9cc9ca1583b754d9.png";